/**
 * Shared Validators using Zod
 */
import { z } from "zod";

// ============================================
// ROUND EXPANDER VALIDATORS
// ============================================

export * from "./roundExpander.schema";

// ============================================
// SCRAPER CONFIG VALIDATORS
// ============================================

export * from "./scraperConfig.schema";

// ============================================
// VARIANT VALIDATORS
// ============================================

export * from "./variant.schema";

// ============================================
// BATCH IMPORT VALIDATORS
// ============================================

export * from "./batchImport.schema";

// ============================================
// ROLE VALIDATORS
// ============================================

export * from "./role.schema";

// ============================================
// AUTH VALIDATORS
// ============================================

export const loginSchema = z.object({
  username: z.string().min(3).max(50),
  password: z.string().min(8),
});

export const registerSchema = z.object({
  username: z.string().min(3).max(50),
  email: z.string().email(),
  password: z
    .string()
    .min(8)
    .regex(/[A-Z]/, "Password must contain at least one uppercase letter"),
});

export const createUserSchema = z.object({
  username: z.string().min(3).max(50),
  email: z.string().email(),
  password: z.string().min(8, "Password must be at least 8 characters"),
  role_id: z.number().optional(),
});

export const changePasswordSchema = z.object({
  currentPassword: z.string(),
  newPassword: z
    .string()
    .min(8)
    .regex(/[A-Z]/, "Password must contain at least one uppercase letter"),
});

export type LoginInput = z.infer<typeof loginSchema>;
export type RegisterInput = z.infer<typeof registerSchema>;
export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;

// ============================================
// JOB VALIDATORS
// ============================================

export const jobSchema = z.object({
  search_url: z.string().url(),
  search_params: z.record(z.unknown()),
});

export type JobInput = z.infer<typeof jobSchema>;

// ============================================
// ROUND CONFIG VALIDATORS
// ============================================

export const roundConfigSchema = z.object({
  config_name: z.string().min(1).max(200),
  config_data: z.record(z.unknown()), // JSON object
  is_active: z.boolean().optional(),
});

export type RoundConfigInput = z.infer<typeof roundConfigSchema>;

// ============================================
// BATCH LIST VALIDATORS
// ============================================

export const batchListSchema = z.object({
  name: z.string().min(1).max(200),
  description: z.string().max(1000).nullable().optional(),
});

export type BatchListInput = z.infer<typeof batchListSchema>;

// ============================================
// FAVORITE VALIDATORS
// ============================================

export * from "./favorite.schema";
export * from "./jobFavorite.schema";

// ============================================
// TAG VALIDATORS
// ============================================

export * from "./tag.schema";

// ============================================
// NOTE VALIDATORS
// ============================================

export * from "./note.schema";

// ============================================
// SHARE VALIDATORS
// ============================================

export * from "./share.schema";

// ============================================
// EXPORT VALIDATORS
// ============================================

export * from "./export.schema";

// ============================================
// SEARCH VALIDATORS
// ============================================

export * from "./search.schema";

// ============================================
// NOTIFICATION VALIDATORS
// ============================================

export * from "./notification.schema";

// ============================================
// PRICE STATS VALIDATORS
// ============================================

export * from "./priceStats.schema";

// ============================================
// EXTENSION VALIDATORS
// ============================================

export * from "./extension.schema";

// ============================================
// SITE CONFIG VALIDATORS
// ============================================

export * from "./siteConfig.schema";

export * from "./browserUpdate.schema";
